import { styled } from './../../styles/theme.config.js';

export const Container = styled('div', {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    flexDirection  : 'column',
    width          : '100vw',
    zIndex         : -1,
    backgroundColor: '$grey',
    color          : '$white',
})

export const Content = styled('div', {
    display : 'flex',
    justifyContent : 'space-between',
    '@media only screen and (max-width : 600px)' :{
        flexDirection : 'column',
        alignItems : 'flex-start',
        justifyContent : 'left',
    },
})

export const Box = styled('div', {
    margin : '3em 6em',
    '@media only screen and (max-width : 600px)' :{
        margin : '1em 2em',
    },
})

export const Header = styled('h1', {
    margin : '1em 0'
})

export const Text = styled('p', {
    margin : '1em 0',
    color : '#cccccc',
})

export const BoldText = styled('p', {
    margin : '2em 0',
    fontWeight : 'bold',
})

export const ListText = styled('a', {
    margin : '1em 0',
    display : 'block',
    textDecoration : 'none',
    color : '$white',
    '&:hover' : {
        color : '#cccccc',
    }
})

export const BrandBox = styled('div', {
    padding : '0 3em 0 0',
    '@media only screen and (max-width : 600px)' :{
        padding : 0
    },
})